module.exports = __webpack_public_path__ + "static/AngelaHe5-b614337622b6fefc21cadeadca6aa64a.webp";